import script from "./MeltingSpotWidget.vue?vue&type=script&setup=true&lang=ts"
export * from "./MeltingSpotWidget.vue?vue&type=script&setup=true&lang=ts"

import "./MeltingSpotWidget.vue?vue&type=style&index=0&id=d79560c6&lang=scss&scoped=true"
import "./MeltingSpotWidget.vue?vue&type=style&index=1&id=d79560c6&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d79560c6"]])

export default __exports__